// The longest search (`q`) the admin list endpoints run. The API answers 422
// past it; the web caps the admin search boxes here and reads an oversize URL
// value as absent, so a long paste never turns the whole list into an error.
export const ADMIN_SEARCH_MAX = 200;
//# sourceMappingURL=admin-search.js.map